import { finishedMissionStatus, FinishedMissionStatus } from '../../../../../../shared/utils/finished-mission-status';
import { Component, Input, OnInit } from '@angular/core';
import { CandidatesApplied, Mission } from '../../../../../../models/Mission';
import { candidatAccepted } from '../../../../../../shared/utils/data/shared.data';
import {
  CandidatStatusOnMission,
  FlagType,
  MissionStatusEnum,
} from '../../../../../../shared/utils/enums';
import { EstablishmentService } from '../../../../../../services/establishment.service';
import moment from 'moment';
import { Router } from '@angular/router';
import { CustomDialogComponent } from '../../../../../../shared/custom-dialog/custom-dialog.component';
import { EtablissementData } from '../../../../../../shared/utils/data/etablissments-data';
import { MissionService } from '../../../../../../services/mission.service';
import { MatDialog } from '@angular/material/dialog';
import { isMissionExpired } from '../../../../../../shared/utils/utils.functions';
import { DocuSignDialogComponent } from '../../../../../../shared/docu-sign-dialog/docu-sign-dialog.component';
import { DocuSignService } from '../../../../../../services/docu-sign.service';

@Component({
  selector: 'app-table-en-cour-action',
  templateUrl: './table-en-cour-action.component.html',
  styleUrl: './table-en-cour-action.component.scss',
})
export class TableEnCourActionComponent implements OnInit {
  /** Statut d'une mission TERMINÉE, calculé sur les candidatures actives (voir finished-mission-status.ts). */
  finishedStatus: FinishedMissionStatus = { label: 'Terminée', css: 'required' };

  @Input() data: Mission;
  @Input() column: any;

  candidatList: CandidatesApplied[] = [];
  candidatAccepted: CandidatesApplied[] = [];
  indexAcceptedCandidate: number;

  statusCandidateAccepted: CandidatStatusOnMission;
  expired = false;
  loadingContract = false;

  constructor(
    private establishmentService: EstablishmentService,
    private router: Router,
    private missionService: MissionService,
    private dialog: MatDialog,
    private docuSign: DocuSignService
  ) {}

  ngOnInit(): void {
    this.expired = isMissionExpired(this.data.enddate, this.data.endtime);
    this.candidatList = this.data.candidatesApplied;
    this.finishedStatus = finishedMissionStatus(this.candidatList);
    
    this.indexAcceptedCandidate = this.candidatList?.findIndex((c) =>
      candidatAccepted.includes(c.statusOfCandidatOnMission)
    );
    if (this.indexAcceptedCandidate > -1) {
      this.statusCandidateAccepted =
        this.candidatList[
          this.indexAcceptedCandidate
        ].statusOfCandidatOnMission;
    }
  }
  get totallyValidated() {
    if (['VALIDATED', 'INVALIDATED'].includes(this.data.missionStatus)) {
      return this.data.missionStatus == 'VALIDATED' ? 'Validée' : 'Non validée';
    }
    return false;
  }

  goTo(): void {
    this.router.navigate([`/dashboard/missions/add/${this.data.id}`]);
  }
  deleteMission() {
    const dialogRef = this.dialog.open(CustomDialogComponent, {
      data: {
        title: EtablissementData.mission.deleteMission.title,
        description: EtablissementData.mission.deleteMission.description,
        primaryLabel: EtablissementData.mission.deleteMission.primaryButton,
        secondaryLabel: EtablissementData.mission.deleteMission.secondButton,
      },
      maxWidth: '464px',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        this.missionService.deleteDraft(this.data.id).subscribe((res) => {
          // this.personService.toggleRefreshData();
          this.missionService.toggleRefreshMission();
        });
      }
    });
  }

  generateContract() {
    this.loadingContract = true;
    this.establishmentService
      .generateContract(
        this.candidatList[this.indexAcceptedCandidate].candidatId,
        this.data.id,
        this.data.etablissementId
      )
      .subscribe({
        next: () => {
          this.establishmentService
            .generateContractPreview(
              this.candidatList[this.indexAcceptedCandidate].candidatId,
              this.data.id,
              this.data.etablissementId
            )
            .subscribe({
              next: (value) => {
                this.loadingContract = false;
                this.docuSign.openDocuSignDialog(value);
              },
              error: (error) => {
                this.loadingContract = false;
              },

              // window.open(value, "_blank");
            });
        },
        error: (err) => {
          this.loadingContract = false;
        },
      });
  }

  protected readonly CandidatStatusOnMission = CandidatStatusOnMission;
  protected readonly MissionStatusEnum = MissionStatusEnum;
}
